import {z} from "zod/v4-mini"
import type {Evaluator} from "@cm/graph-v3"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode, nodeOwnerMarker, getTemplateNodeReturns, visitAll} from "@cm/template-nodes"
import type {
    NodeOwnerLikeNode,
    OnCompileContext,
    OnFilterActiveContext,
    TemplateNodeContext,
    TemplateNodeDefinition,
    VisitorNodeResult,
} from "@cm/template-nodes"
import {MattressNode} from "#mattress/nodes/mattress-node"
import {MattressNodes} from "#mattress/nodes/mattress-nodes"

export type MattressGroupParameters = {
    name: string
    nodes: MattressNodes
}

const definition: TemplateNodeDefinition<MattressGroupParameters> = {
    nodeClass: "MattressGroup",
    validation: {
        parameters: z.object({
            name: z.string(),
            nodes: graphNode(MattressNodes),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MattressGroup extends MattressNode<MattressGroupParameters> implements NodeOwnerLikeNode {
    get [nodeOwnerMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    public override onFilterActive(_context: OnFilterActiveContext, evaluator: Evaluator<TemplateNodeContext>): VisitorNodeResult<MattressGroupParameters> {
        return visitAll(this.parameters, evaluator)
    }

    public override onCompile(_context: OnCompileContext, evaluator: Evaluator<TemplateNodeContext>): VisitorNodeResult<MattressGroupParameters> {
        return visitAll(this.parameters, evaluator)
    }
}
